import { reactive, ref } from "@vue/composition-api";
import { getAzureConfig } from "./azureConfig";
import { useMemberDetails } from "./member-details";

const {
  serviceName,
  workplaceIndexName,
  queryKey,
  suggesterName,
} = getAzureConfig();

let chosenWorkplace;

export function useWorkplaceSearch() {
  let member =
    window.Distinction && window.Distinction.member
      ? window.Distinction.member
      : {};
  let workplace = member.Workplace || {};
  const workplaces = ref([]);
  chosenWorkplace =
    chosenWorkplace ||
    reactive({
      id: workplace.WorkplaceId || "",
      name: workplace.WorkplaceName || "",
      trustName: workplace.TrustName || "",
      regionName: workplace.RegionName || "",
      workplaceId: workplace.WorkplaceId || "",
    });

  const { isAgencyWorker } = useMemberDetails();

  async function doSearch(searchTerm) {
    if (searchTerm === "") {
      workplaces.value = [];
      return;
    }

    var resp = await fetch(
      `https://${serviceName}.search.windows.net/indexes/${workplaceIndexName}/docs/suggest?api-version=2020-06-30`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "api-key": queryKey, // query-only key
        },
        body: JSON.stringify({
          search: searchTerm,
          highlightPreTag: "<b>",
          highlightPostTag: "</b>",
          suggesterName,
          filter: `dateClosed eq null or dateClosed gt ${new Date().toISOString()}`,
          select: "id,name,address1,regionName,trustName",
        }),
      },
    );

    var { value } = await resp.json();
    workplaces.value = value;
  }

  function selectWorkplace(workplace) {
    chosenWorkplace.name = workplace.name;
    chosenWorkplace.trustName = workplace.trustName;
    chosenWorkplace.regionName = workplace.regionName;
    chosenWorkplace.workplaceId = workplace.id;
  }

  function setIsAgencyWorker(val) {
    isAgencyWorker.value = val;
  }

  return {
    workplaces,
    doSearch,
    chosenWorkplace,
    selectWorkplace,
    isAgencyWorker,
    setIsAgencyWorker,
  };
}
